import { Component, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'conn-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.css'],
  standalone: false,
})
export class ErrorMessageComponent {
  showError = false;
  @Input() genericMessage: string;
  @Input() errorMessage: HttpErrorResponse | string | null;

  getGenericErrorMessage(): string {
    return this.genericMessage
      ? this.genericMessage
      : 'An error occurred while trying to perform your query.';
  }

  getErrorResponse(): HttpErrorResponse | string | null {
    return this.errorMessage;
  }

  dismissError() {
    this.errorMessage = null;
  }

  toggleError() {
    this.showError = !this.showError;
  }
}
